"use strict";
/*
 * Integration App React package
 * {@link https://www.npmjs.com/package/@integration-app/react}
 * v2.18.0
 */
'use client';

import { DataBuilderFormulaType } from '@integration-app/sdk';
import CaseFormula, { CaseFormulaDropdown } from './case.mjs';
import ConcatFormula, { ConcatFormulaDropdown } from './concat.mjs';
import CopyFormula, { CopyFormulaDropdown } from './copy.mjs';
import DomainFromEmailFormula, { DomainFromEmailFormulaDropdown } from './domainFromEmail.mjs';
import ExtractDateFormula, { ExtractDateFormulaDropdown } from './extractDate.mjs';
import ExtractTimeFormula, { ExtractTimeFormulaDropdown } from './extractTime.mjs';
import FindAppRecordIdFormula, { FindAppRecordIdFormulaDropdown } from './findAppRecordId.mjs';
import FindExternalRecordIdFormula, { FindExternalRecordIdFormulaDropdown } from './findExternalRecordId.mjs';
import FirstNameFormula, { FirstNameFormulaDropdown } from './firstName.mjs';
import FirstNotEmptyFormula, { FirstNotEmptyDropdown } from './firstNotEmpty.mjs';
import IterateFormula, { IteratedFormulaDropdown } from './iterate.mjs';
import JsonataFormulaTag, { JsonataFormulaDropdown } from './jsonata.mjs';
import LastNameFormula, { LastNameFormulaDropdown } from './lastName.mjs';
import LookupFormula from './lookup.mjs';
import MapFormula, { MapFormulaDropdown } from './map.mjs';
import MergeObjectsFormula, { MergeObjectsDropdown } from './mergeObjects.mjs';
import NoUiFormula from './noUi.mjs';
import RecordFormula from './record.mjs';
import TplFormula from './tpl.mjs';
import VarFormula from './var.mjs';

const formulaComponentMapping = {
  [DataBuilderFormulaType.DATA_SCHEMA_REF]: {
    component: NoUiFormula
  },
  [DataBuilderFormulaType.VAR]: {
    component: VarFormula
  },
  [DataBuilderFormulaType.TPL]: {
    component: TplFormula
  },
  [DataBuilderFormulaType.RECORD]: {
    component: RecordFormula
  },
  [DataBuilderFormulaType.FIRST_NAME]: {
    component: FirstNameFormula,
    DropdownComponent: FirstNameFormulaDropdown
  },
  [DataBuilderFormulaType.LAST_NAME]: {
    component: LastNameFormula,
    DropdownComponent: LastNameFormulaDropdown
  },
  [DataBuilderFormulaType.ITERATE]: {
    component: IterateFormula,
    DropdownComponent: IteratedFormulaDropdown
  },
  [DataBuilderFormulaType.CONCAT]: {
    component: ConcatFormula,
    DropdownComponent: ConcatFormulaDropdown
  },
  [DataBuilderFormulaType.LOOKUP]: {
    component: LookupFormula
  },
  [DataBuilderFormulaType.MAP]: {
    component: MapFormula,
    DropdownComponent: MapFormulaDropdown
  },
  [DataBuilderFormulaType.CASE]: {
    component: CaseFormula,
    DropdownComponent: CaseFormulaDropdown
  },
  [DataBuilderFormulaType.PLAIN]: {
    component: NoUiFormula
  },
  [DataBuilderFormulaType.EXTRACT_DATE]: {
    component: ExtractDateFormula,
    DropdownComponent: ExtractDateFormulaDropdown
  },
  [DataBuilderFormulaType.EXTRACT_TIME]: {
    component: ExtractTimeFormula,
    DropdownComponent: ExtractTimeFormulaDropdown
  },
  [DataBuilderFormulaType.COPY]: {
    component: CopyFormula,
    DropdownComponent: CopyFormulaDropdown
  },
  [DataBuilderFormulaType.FIND_APP_RECORD_ID]: {
    component: FindAppRecordIdFormula,
    DropdownComponent: FindAppRecordIdFormulaDropdown
  },
  [DataBuilderFormulaType.FIND_EXTERNAL_RECORD_ID]: {
    component: FindExternalRecordIdFormula,
    DropdownComponent: FindExternalRecordIdFormulaDropdown
  },
  [DataBuilderFormulaType.EVAL]: {
    component: NoUiFormula
  },
  [DataBuilderFormulaType.AND]: {
    component: NoUiFormula
  },
  [DataBuilderFormulaType.OR]: {
    component: NoUiFormula
  },
  [DataBuilderFormulaType.MERGE_OBJECTS]: {
    component: MergeObjectsFormula,
    DropdownComponent: MergeObjectsDropdown
  },
  [DataBuilderFormulaType.FIRST_NOT_EMPTY]: {
    component: FirstNotEmptyFormula,
    DropdownComponent: FirstNotEmptyDropdown
  },
  [DataBuilderFormulaType.DOMAIN_FROM_EMAIL]: {
    component: DomainFromEmailFormula,
    DropdownComponent: DomainFromEmailFormulaDropdown
  },
  [DataBuilderFormulaType.FORMULA]: {
    component: NoUiFormula
  },
  [DataBuilderFormulaType.JSONATA]: {
    component: JsonataFormulaTag,
    DropdownComponent: JsonataFormulaDropdown
  }
};

export { formulaComponentMapping };
